import { render, staticRenderFns } from "./PromotionReport.vue?vue&type=template&id=5dd01e4d&scoped=true&"
import script from "./PromotionReport.vue?vue&type=script&lang=js&"
export * from "./PromotionReport.vue?vue&type=script&lang=js&"
import style0 from "./PromotionReport.vue?vue&type=style&index=0&id=5dd01e4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd01e4d",
  null
  
)

export default component.exports